import { render, staticRenderFns } from "./comment-sell.vue?vue&type=template&id=d551d614&"
import script from "./comment-sell.vue?vue&type=script&lang=js&"
export * from "./comment-sell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports